import React, { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import { companyData, services, technologies, contactMethods, contactIcons } from './companyData';
import { downloadProfile, downloadPDF, downloadContact } from './downloadUtils';

// Simple icons as SVG components
const MailIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.44a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg
    className="w-6 h-6"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M20.52 3.48A11.8 11.8 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.98L0 24l6.22-1.62A11.95 11.95 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 22a10.01 10.01 0 01-5.1-1.4l-.36-.21-3.69.96.99-3.6-.24-.37A10 10 0 1122 12c0 5.52-4.48 10-10 10zm5.28-7.38c-.29-.15-1.73-.85-2-1-.27-.1-.46-.15-.65.15s-.75 1-.92 1.2c-.17.19-.34.21-.63.07-.29-.15-1.22-.45-2.33-1.42-.86-.76-1.44-1.7-1.61-1.99-.17-.29-.02-.45.13-.59.14-.14.29-.34.44-.5.15-.17.2-.29.3-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.16-.23-.56-.47-.49-.65-.5h-.56c-.19 0-.5.07-.76.36s-1 1-.98 2.47 1.02 2.87 1.16 3.06c.15.2 2 3.04 4.94 4.27.69.3 1.23.48 1.65.62.69.22 1.32.19 1.82.12.56-.08 1.73-.7 1.97-1.37.24-.68.24-1.26.17-1.38-.06-.12-.26-.2-.55-.35z"
    />
  </svg>
);

const LinkedinIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const MapIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const GlobeIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

const DownloadIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const EyeIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

const FileTextIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const LeafIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.06.82C6.16 17.4 9 14.3 17 8zm3.5-2c-1.33 0-2.42 1.08-2.42 2.42 0 4.54-5.58 8.58-9.08 8.58v2c5.33 0 11.5-6.22 11.5-10.58 0-2.5-2.04-4.42-4.5-4.42z"/>
  </svg>
);

const SparklesIcon = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M9.5 2l1.5 5L16 8.5 11 9.5 9.5 14 8 9.5 3 8.5 8 7.5 9.5 2zm6.5 7l.75 2.5L19 12.25l-2.25.75L16 15.5l-.75-2.5L13 12.25l2.25-.75L16 9zm-10 8l.5 1.5L8 19l-1.5.5L6 21l-.5-1.5L4 19l1.5-.5L6 17z"/>
  </svg>
);

const StarIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);

const iconMap = {
  Mail: MailIcon,
  Phone: PhoneIcon,
  MessageCircle: WhatsAppIcon,
  Linkedin: LinkedinIcon,
  MapPin: MapIcon,
  Globe: GlobeIcon,
  Download: DownloadIcon,
  Eye: EyeIcon,
  FileText: FileTextIcon,
  Leaf: LeafIcon,
  Sparkles: SparklesIcon,
  Star: StarIcon
};

function FloatingElements() {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    const newElements = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      delay: Math.random() * 5,
      duration: 8 + Math.random() * 4
    }));
    setElements(newElements);
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {elements.map((element) => (
        <div
          key={element.id}
          className="absolute opacity-20 animate-float"
          style={{
            left: `${element.x}px`,
            top: `${element.y}px`,
            animationDelay: `${element.delay}s`,
            animationDuration: `${element.duration}s`
          }}
        >
          <LeafIcon />
        </div>
      ))}
    </div>
  );
}

export default function Landing() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      <FloatingElements />
      
      {/* Hero Section */}
      <section
        className={`min-h-screen flex flex-col items-center justify-center px-4 relative z-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-5" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="relative py-4 mt-4 mb-8">
          <div className="relative">
            <div className="w-40 h-40 rounded-full bg-gradient-to-br from-emerald-100 via-teal-100 to-cyan-100 p-2 shadow-2xl">
              <img
                src="/logocomp.png"
                alt="Hirwai Landscape - Beautiful Gardens"
                className="w-full h-full rounded-full object-cover border-4 border-white"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              <div className="w-full h-full rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 hidden items-center justify-center text-white text-4xl font-bold">
                H
              </div>
            </div>
            <div className="absolute -bottom-2 -right-2 bg-emerald-400 text-white p-3 rounded-full shadow-lg animate-pulse-slow">
              <LeafIcon />
            </div>
            <div className="absolute -top-4 -left-4 bg-teal-400 text-white p-2 rounded-full">
              <SparklesIcon />
            </div>
          </div>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-5xl font-serif font-bold text-slate-800 mb-3 tracking-tight">
            Hirwai Landscape
          </h1>
          <div className="flex items-center justify-center gap-2 mb-4">
            <StarIcon />
            <p className="text-2xl text-emerald-700 font-medium">
              Crafting Green Dreams
            </p>
            <StarIcon />
          </div>
          <p className="text-slate-600 max-w-md mx-auto leading-relaxed">
            Transforming spaces into sustainable sanctuaries with passion,
            expertise, and innovative design
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {contactIcons.map((contact, index) => {
            const IconComponent = iconMap[contact.icon];
            return (
              <a
                key={contact.label}
                href={contact.href}
                className="p-4 bg-white/70 backdrop-blur-sm rounded-2xl hover:bg-white/90 transition-all duration-300 group shadow-lg border border-white/50 btn-hover"
                style={{ animationDelay: `${0.9 + index * 0.1}s` }}
              >
                <div
                  className={`${contact.color} group-hover:scale-110 transition-transform`}
                >
                  <IconComponent />
                </div>
              </a>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
      
          {/* <button
            onClick={downloadPDF}
            className="bg-cyan-300 text-slate-900 font-semibold py-3 px-6 rounded-full flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transition-all duration-300 btn-hover"
          >
            <FileTextIcon />
            <span>📑 Download Profile (PDF)</span>
          </button> */}
          <a
  href="/Hirwai-FINAL.pdf"
  download
  className="bg-cyan-300 text-slate-900 font-semibold py-3 px-6 rounded-full flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transition-all duration-300 btn-hover"
>
  📑 Download Profile
</a>

          <button
            onClick={scrollToServices}
            className="bg-emerald-100 text-emerald-700 font-semibold py-3 px-6 rounded-full flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transition-all duration-300 btn-hover"
          >
            <EyeIcon />
            <span>🔗 View Portfolio</span>
          </button>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800 mb-4">
              Our Services
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
              Comprehensive landscape solutions designed to bring your green
              dreams to life
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <ServiceCard
                key={service.title}
                service={service}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-4 bg-white/50 backdrop-blur-sm relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-800 mb-6">
              Who We Are
            </h2>
          </div>

          <div className="space-y-8">
            <div className="bg-white/70 backdrop-blur-sm p-8 rounded-3xl shadow-lg border border-emerald-100">
              <p className="text-slate-700 text-lg leading-relaxed mb-6">
                Hirwai Landscape is a passionate team of horticulturists and
                designers committed to transforming everyday spaces into green
                sanctuaries. From terrace gardens to sprawling landscapes, our
                designs are rooted in sustainability, beauty, and functionality.
              </p>

              <p className="text-slate-700 text-lg leading-relaxed">
                With 100+ projects completed, we bring over a decade of
                experience blending technology with nature. We believe in green
                solutions that are smart, elegant, and environmentally
                responsible.
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-100 to-teal-100 p-8 rounded-3xl">
              <h3 className="text-2xl font-semibold text-slate-800 mb-6 flex items-center gap-3">
                <SparklesIcon />
                Technologies We Use
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {technologies.map((tech, index) => (
                  <div
                    key={tech}
                    className="flex items-center gap-4 p-4 bg-white/60 backdrop-blur-sm rounded-2xl shadow-sm hover:scale-105 hover:translate-x-1 transition-all duration-300"
                  >
                    <div className="w-3 h-3 bg-gradient-to-r from-emerald-400 to-teal-500 rounded-full"></div>
                    <span className="text-slate-700 font-medium">{tech}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-800 via-slate-900 to-black text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          {Array.from({ length: 50 }, (_, i) => (
            <div
              key={i}
              className="absolute animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${6 + Math.random() * 4}s`,
              }}
            >
              <LeafIcon />
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-4xl text-green-700 font-bold mb-4">Get In Touch</h2>
            <p className="text-xl text-slate-300">
              Ready to transform your space? Let's create something beautiful
              together
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
            {contactMethods.map((method, index) => {
              const IconComponent = iconMap[method.icon];
              return (
                <a
                  key={method.type}
                  href={method.href}
                  className="flex items-center gap-4 p-6 bg-white/10 backdrop-blur-sm rounded-2xl hover:bg-white/20 transition-all duration-300 border border-white/20 btn-hover"
                >
                  <div className="p-3 bg-emerald-500/20 rounded-xl">
                    <div className="text-emerald-400">
                      <IconComponent />
                    </div>
                  </div>
                  <div>
                    <span className="text-lg block">{method.text}</span>
                    <span className="text-base text-gray-200 block">
                      {method.value}
                    </span>
                  </div>
                </a>
              );
            })}
          </div>

          <div className="text-center">
            <button
              onClick={downloadContact}
              className="bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-semibold py-4 px-8 rounded-full flex items-center gap-3 mx-auto shadow-lg hover:shadow-xl transition-all duration-300 btn-hover"
            >
              <DownloadIcon />
              Save Contact Details
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <LeafIcon />
            <h3 className="text-2xl font-serif text-green-700 font-bold">Hirwai Landscape</h3>
            <LeafIcon />
          </div>
          <p className="text-slate-400 mb-6">
            Crafting Green Dreams • Sustainable • Beautiful • Functional
          </p>
          <p className="text-slate-500 text-sm">
            © 2024 Hirwai Landscape. All rights reserved. | Designed with 💚 for
            nature lovers
          </p>
        </div>
      </footer>
    </div>
  );
}